import { render, staticRenderFns } from "./warrantyProps.pug?vue&type=template&id=94defdc6&lang=pug&"
import script from "./warrantyProps.js?vue&type=script&lang=js&"
export * from "./warrantyProps.js?vue&type=script&lang=js&"
import style0 from "./warrantyProps.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94defdc6')) {
      api.createRecord('94defdc6', component.options)
    } else {
      api.reload('94defdc6', component.options)
    }
    module.hot.accept("./warrantyProps.pug?vue&type=template&id=94defdc6&lang=pug&", function () {
      api.rerender('94defdc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantyProps/index.vue"
export default component.exports